import React from 'react';
import { hydrateRoot } from 'react-dom/client'
import loadable from '@loadable/component'
import { loadableReady } from '@loadable/component'
import moment from 'moment';
import 'moment/locale/tr'
import {HelmetProvider} from 'react-helmet-async'
import * as serviceWorker from './serviceWorker';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import {
  ApolloProvider,
  ApolloClient,
  createHttpLink,
  InMemoryCache
} from '@apollo/client';

import {SsrContext} from './useSsr'
import TENANT_TO_LANG from './common/TENANT_TO_LANG'
const GasteArsivi = loadable(() => import('./App'))

const host = window.location.host
const gaRegex = /.*.gastearsivi.com/
const tenant = host.match(gaRegex) 
  ? "gastearsivi" : 'historyworm'

const lang = TENANT_TO_LANG[tenant]

const gqlClient = new ApolloClient({
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
  link: createHttpLink({
    uri: `${process.env.REACT_APP_GA_API_URL}/graphql`,
    credentials: 'include',
  }),
});
  
//localeyi burada bir kere set etmek yeterli
moment.locale(lang)

const AppContainer = () => {
  return <HelmetProvider>
      <ApolloProvider client={gqlClient}>
        <Router>
          <SsrContext.Provider value={{isSsr: false, context: {}}}>
            <GasteArsivi lang={lang} tenant={tenant}/>
          </SsrContext.Provider> 
        </Router>
    </ApolloProvider>
  </HelmetProvider>
}

loadableReady(() => {
  hydrateRoot(
    document.getElementById('root'),
    <AppContainer /> 
  )
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
